// import { LuPlus, LuSearch } from "react-icons/lu";
// import UsersFilter from "./UsersFilter";

// export default function UsersToolbar({
//   searchValue,
//   onSearchChange,
//   role,
//   status,
//   onRoleChange,
//   onStatusChange,
//   onAddClick,
// }) {
//   return (
//     <div className="flex flex-col gap-3 border-b border-slate-100 bg-gradient-to-r from-brand-50/70 via-white to-white p-4 sm:flex-row sm:items-center sm:justify-between">
//       <div>
//         <h1 className="text-lg font-bold text-slate-900">Users</h1>
//         <p className="text-[13px] text-slate-500">Manage your organization's members and admins.</p>
//       </div>

//       <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
//         <div className="relative">
//           <LuSearch
//             className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400"
//             size={15}
//           />
//           <input
//             value={searchValue}
//             onChange={(e) => onSearchChange(e.target.value)}
//             placeholder="Search users…"
//             className="h-9 w-full rounded-md border border-slate-300 pl-8 pr-3 text-[13px] outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20 sm:w-56"
//           />
//         </div>

//         <UsersFilter role={role} status={status} onRoleChange={onRoleChange} onStatusChange={onStatusChange} />

//         <button
//           onClick={onAddClick}
//           className="flex h-9 items-center gap-1.5 rounded-lg bg-brand-gradient px-3.5 text-[13px] font-semibold text-white shadow-brand transition-transform hover:scale-[1.02] active:scale-[0.98]"
//         >
//           <LuPlus size={14} />
//           Add User
//         </button>
//       </div>
//     </div>
//   );
// }






import UsersFilter from "./UsersFilter";
import ListToolbar from "../../../common/ListToolbar";

export default function UsersToolbar({
  searchValue,
  onSearchChange,
  role,
  status,
  onRoleChange,
  onStatusChange,
  onAddClick,
}) {
  return (
    <ListToolbar
      title="Users"
      subtitle="Manage your organization's members and admins."
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search users…"
      filters={
        <UsersFilter
          role={role}
          status={status}
          onRoleChange={onRoleChange}
          onStatusChange={onStatusChange}
        />
      }
      addLabel="Add User"
      onAddClick={onAddClick}
    />
  );
}